import * as z from "zod/v4";

export const retryMarketplaceNotification = {
  name: "retryMarketplaceNotification" as const,
  input: z.object({ fulfillmentGroupId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
